(function () {
  function formatIndian(num) {
    if (isNaN(num)) return num;
    const n = parseFloat(num);
    const parts = n.toFixed(2).split('.');
    const intPart = parts[0];
    const decPart = parts[1];

    let lastThree = intPart.slice(-3);
    const otherNumbers = intPart.slice(0, -3);
    if (otherNumbers !== '') {
      lastThree = ',' + lastThree;
    }
    const formatted = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    return decPart === '00' ? formatted : formatted + '.' + decPart;
  }

  function reformatTextNode(node) {
    const text = node.nodeValue;
    const updated = text.replace(/₹\s*([\d,]+(?:\.\d+)?)/g, (match, num) => {
      const cleanNum = num.replace(/,/g, '');
      return '₹' + formatIndian(cleanNum);
    });
    if (updated !== text) {
      node.nodeValue = updated;
    }
  }

  function walkAndReformat(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          // Skip script and style tags
          const parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          const tag = parent.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE') return NodeFilter.FILTER_REJECT;
          // Only process nodes that contain ₹
          if (!node.nodeValue.includes('₹')) return NodeFilter.FILTER_SKIP;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(reformatTextNode);
  }

  let debounceTimer;
  function debouncedWalk() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => walkAndReformat(document.body), 80);
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', () => walkAndReformat(document.body));

  // Shopify section reloads (theme editor)
  document.addEventListener('shopify:section:load', debouncedWalk);

  // Catch variant switches, cart drawer AJAX updates, etc.
  const observer = new MutationObserver(debouncedWalk);
  observer.observe(document.body, { childList: true, subtree: true });
})();
